import React, { createContext, useContext, useMemo } from "react";
import mx from "./mx.json";
import en from "./en.json";

const DICTS = { mx, en };

const I18nContext = createContext({ lang: "mx", t: (k) => k, dict: mx });

export const I18nProvider = ({ lang, children }) => {
  const dict = DICTS[lang] || DICTS.mx;

  const value = useMemo(() => {
    const t = (path, fallback = "") => {
      const parts = path.split(".");
      let node = dict;
      for (const p of parts) {
        if (node && typeof node === "object" && p in node) {
          node = node[p];
        } else {
          return fallback || path;
        }
      }
      return node;
    };
    return { lang, t, dict };
  }, [lang, dict]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
